import styled from 'styled-components';

import { A } from '@main/pc-core-components';

/**
 * Login link wrapper
 */
export const LinkWrapper = styled(A)`
  text-align: center;
  font-weight: 400;
  font-family: '${({ theme }) => theme.textStyles.fontFamilyBody.name}';
`;
